import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
export default (...objects) => {
  return false ? require('identity-obj-proxy') : _Object$assign({}, ...objects);
};